import { useOptionsStore } from '@shared/model'

import { useCustomerStore } from './customer-store/store'

export const useOptionsDiscount = (): ComputedRef<number> => {
  const optionsStore = useOptionsStore()
  const customerStore = useCustomerStore()

  return computed<number>(() => (customerStore.isTypePaid ? optionsStore.getUpsellDiscount : optionsStore.getPadDefaultDiscount))
}
